<template>
  <div class="category-list-layer">
    <button type="button" @click="openCategoryLayout" class="btn-all-category" data-gnb="category-menu">전체 카테고리 보기</button>
    <template v-for="(sectionInfo, index) in multiSectionList">
      <dynamic-section-loader :section-info="sectionInfo" :key="'categoryGroups_' + index"></dynamic-section-loader>
    </template>
  </div>
</template>

<script>
import {
  CATEGORY_BAND_NUMBER_KEY,
  CATEGORY_CTYPE_MENU,
  categoryInfo,
  EVENT_OPEN_CATEGORY_LAYOUT,
  setCategoryMenu
} from '@/common/utils/gnb.category'
import _ from 'lodash'
import DynamicSectionLoader from '@/components/container/DynamicSectionLoader'
import { getSectionEventByType } from '@/common/utils/gnb.fp'
import { EVENT_TYPE } from '@/common/resources/const'
import { parseUrl } from 'query-string'

export default {
  name: 'CategoryMenu.vue',
  components: { DynamicSectionLoader },
  data () {
    return {
      multiSectionList: []
    }
  },
  methods: {
    openCategoryLayout () {
      this.$events.$emit(EVENT_OPEN_CATEGORY_LAYOUT)
    },
    fetchMenuList () {
      const fetchFn = categoryInfo.hasMultiSectionResponse()
        ? () => new Promise((resolve) => { resolve(true) }) : setCategoryMenu
      fetchFn().then(() => {
        this.multiSectionList = _.get(categoryInfo, 'multiSectionResponse.data.multisectionlist', [])
          .filter((multiSection) => {
            const onContent = getSectionEventByType(EVENT_TYPE.ON_CONTENT)(multiSection)
            const url = _.get(onContent, 'url', '')
            const { query } = parseUrl(url)
            const cType = _.get(query, 'ctype', '')
            const bandNumber = _.get(multiSection, 'cell_type', '')
            return cType === CATEGORY_CTYPE_MENU && bandNumber === CATEGORY_BAND_NUMBER_KEY
          })
      })
    }
  },
  created () {
    this.fetchMenuList()
  }
}
</script>
